import { render, staticRenderFns } from "./FormAsignarUsuario.vue?vue&type=template&id=56fa9e97"
import script from "./FormAsignarUsuario.vue?vue&type=script&lang=js"
export * from "./FormAsignarUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports